import managerWalletAndRewardAdminPortal from '@assets/images/managerWalletAndRewardAdminPortal.png';

export const AdminPortalContent = [
  {
    title: '🛠️ Admin & User Management',
    image: managerWalletAndRewardAdminPortal.src,
  },
  {
    title: '🎁 Reward Inventory Management',
    image: 'https://via.placeholder.com/151',
  },
  {
    title: '📈 User Engagement Data Dashboard',
    image: 'https://via.placeholder.com/152',
  },
  {
    title: '💬 Employee Feedback Management',
    image: 'https://via.placeholder.com/153',
  },
  {
    title: '🏀 Gamification & Campaign Release',
    image: 'https://via.placeholder.com/154',
  },
  {
    title: '🎛️ Content Management',
    image: 'https://via.placeholder.com/155',
  },
];

export default AdminPortalContent;
